import { DEFAULT_LOCALE, normalizeLocale } from 'civic-champs-translations/src'

import { LOCALE_STORAGE_KEY } from './constants'

export function readStoredLocale() {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (stored) {
      return normalizeLocale(stored)
    }
  } catch (_) {
    // private mode / blocked storage
  }
  return null
}

export function detectBrowserLocale() {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LOCALE
  }

  const candidates = navigator.languages?.length ? navigator.languages : [navigator.language]
  for (const tag of candidates) {
    const normalized = normalizeLocale(tag)
    if (normalized) {
      return normalized
    }
  }

  return DEFAULT_LOCALE
}
